var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 12.4999C13.2812 15.5375 10.7558 18 7.64049 18C4.52519 18 2 15.5382 2 12.4999C2 9.46161 4.52538 7 7.64049 7C10.7556 7 13.2812 9.46235 13.2812 12.4999ZM19.4691 12.4999C19.4691 15.3594 18.2063 17.6773 16.6487 17.6773C15.0912 17.6773 13.8284 15.3586 13.8284 12.4999C13.8284 9.64117 15.0912 7.32256 16.6487 7.32256C18.2063 7.32256 19.4691 9.64117 19.4691 12.4999ZM22 12.4999C22 15.0619 21.5558 17.1386 21.008 17.1386C20.4603 17.1386 20.0161 15.0611 20.0161 12.4999C20.0161 9.93869 20.4603 7.86122 21.0082 7.86122C21.5562 7.86122 22 9.93813 22 12.4999Z",
    fill: "rgba(255, 255, 255, 0.5)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.8a3a9df9.svg";
export { ForwardRef as ReactComponent };